"use client";

// missions-sidebar.jsx // MissionsSidebar Component

/* eslint-disable react-hooks/exhaustive-deps */
import dynamic from "next/dynamic";

import React, { useEffect } from "react";
import { Fragment } from "react";
import Collapsible from "react-collapsible";
import { Icon } from "@iconify/react";
import LeaderBoard from "../partials/app/missions/leaderboard";
import EmailModal from "../partials/header/Tools/email-modal";
import { useRouter } from "next/navigation";
import MessageModal from "@/components/ui/Message-Modal";
import Image from "next/image";
import clipboardCopy from "clipboard-copy";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { toast } from "react-toastify";
import { checkFailedBindsForDisabling } from "@/utils/helpers/helperFunctions";
import { supabase } from "@/supabase/client";
import axios from "axios";

const Button = dynamic(() => import("@/components/ui/Button"));
const LoadingModal = dynamic(() =>
  import("@/components/partials/header/Tools/loading-modal")
);

export default function MissionsSidebar({
  leaderboard,
  leaderboardLoading,
  leaderboardTabChange,
  leaderboardHandleNext,
  leaderboardHandlePrev,
  user,
  userPoints,
  userHandles,
  setTabIndex,
  loading,
  state,
}) {
  const [innerLoading, setInnerLoading] = React.useState(true);
  const [isEmailModalOpen, setIsEmailModalOpen] = React.useState(false);
  const [isLoadingModalOpen, setIsLoadingModalOpen] = React.useState(false);
  const router = useRouter();
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [showErrorModal, setShowErrorModal] = React.useState(false);
  const [activeError, setActiveError] = React.useState(null);
  const [activeErrorTitle, setActiveErrorTitle] = React.useState(null);
  const [claimedRewardAmount, setClaimedRewardAmount] = React.useState(0);
  const [mxs, setMxs] = React.useState(0);
  const [mxsLoading, setMxsLoading] = React.useState(false);
  const [mxsLeaderboard, setMxsLeaderboard] = React.useState({
    leaderboard: [],
    page: 1,
    totalPages: 1,
    hasNext: false,
    hasPrev: false,
    total: 0,
  });
  const [mxsLeaderboardLoading, setMxsLeaderboardLoading] =
    React.useState(true);
  const [mxsUserRow, setMxsUserRow] = React.useState(null);

  useEffect(() => {
    setInnerLoading(true);

    let onbTasks = [...onboardingTasks];

    // console.log('Current user handles:', userHandles);
    // console.log('Initial onboarding tasks state:', onbTasks);

    if (userHandles?.length > 0) {
      onbTasks[0].completed = true;

      userHandles.forEach((handle) => {
        if (handle.handle_name === "email") {
          // console.log('Email verification status:', {
          //   handle_verified: handle.handle_verified,
          //   verified: handle.verified,
          //   reward_claimed: handle.handle_reward_claimed || handle.reward_claimed
          // });
          onbTasks[1].completed = handle.handle_verified || handle.verified;
          onbTasks[1].claimed =
            handle.handle_reward_claimed || handle.reward_claimed;
        }

        if (handle.handle_name === "twitter") {
          // console.log('Twitter verification status:', {
          //   handle_verified: handle.handle_verified,
          //   reward_claimed: handle.handle_reward_claimed || handle.reward_claimed
          // });
          onbTasks[2].completed = handle.handle_verified;
          onbTasks[2].claimed =
            handle.handle_reward_claimed || handle.reward_claimed;
        }

        if (handle.handle_name === "google") {
          // console.log('Google verification status:', {
          //   handle_verified: handle.handle_verified,
          //   reward_claimed: handle.handle_reward_claimed || handle.reward_claimed
          // });
          onbTasks[6].completed = handle.handle_verified;
          onbTasks[6].claimed =
            handle.handle_reward_claimed || handle.reward_claimed;
        }
      });
    } else {
      // console.log('No user handles found');
      onbTasks[0].completed = false;
    }

    // Since profile picture is not on the handles, we should look for it manually in here

    if (
      user?.photo_url !== null &&
      user?.photo_url !== undefined &&
      user?.photo_url !== ""
    ) {
      onbTasks[3].completed = true;
      // In future, we can implement some function to look up rewards collection to check if the reward has been claimed or not
      onbTasks[3].claimed = true;
    }

    // console.log('Final onboarding tasks state:', onbTasks);
    setOnboardingTasks(onbTasks);
    setInnerLoading(false);
  }, [userHandles]);

  React.useEffect(() => {
    const fetchMXS = async () => {
      if (!user || !user.wallet) {
        setMxs(0);
        return;
      }
      setMxsLoading(true);
      const { data, error } = await supabase
        .from("seasons_diff")
        .select("mxs")
        .eq("wallet_lc", user.wallet.toLowerCase())
        .single();
      if (data && typeof data.mxs !== "undefined") {
        setMxs(data.mxs);
      } else {
        setMxs(0);
      }
      setMxsLoading(false);
    };
    fetchMXS();
  }, [user]);

  const fetchMxsLeaderboard = async (page = 1) => {
    try {
      setMxsLeaderboardLoading(true);
      const response = await axios.get(
        `https://cqfjxolodeqrlvaifybm.supabase.co/functions/v1/get-generic-leaderboard?type=mxs&page=${page}&limit=5`,
        {
          headers: {
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_NEAL_SECRET}`,
          },
        }
      );
      let leaderboardData =
        response.data.success && response.data.data
          ? response.data.data
          : {
              leaderboard: [],
              page: 1,
              totalPages: 1,
              hasNext: false,
              hasPrev: false,
              total: 0,
            };
      // Fetch photo_url for each user
      if (
        leaderboardData.leaderboard &&
        leaderboardData.leaderboard.length > 0
      ) {
        const userIds = leaderboardData.leaderboard.map(
          (entry) => entry.user_id
        );
        const { data: usersData, error } = await supabase
          .from("users_duplicate")
          .select("uid, photo_url")
          .in("uid", userIds);
        if (!error && usersData) {
          leaderboardData.leaderboard = leaderboardData.leaderboard.map(
            (entry) => {
              const user = usersData.find((u) => u.uid === entry.user_id);
              return { ...entry, photo_url: user?.photo_url };
            }
          );
        }
      }
      setMxsLeaderboard(leaderboardData);
    } catch (error) {
      setMxsLeaderboard({
        leaderboard: [],
        page: 1,
        totalPages: 1,
        hasNext: false,
        hasPrev: false,
        total: 0,
      });
    } finally {
      setMxsLeaderboardLoading(false);
    }
  };

  React.useEffect(() => {
    fetchMxsLeaderboard();
    // Fetch current user's MXS leaderboard row directly from seasons_diff
    const fetchUserMxsRow = async () => {
      if (!user || !user.user_id) {
        setMxsUserRow(null);
        return;
      }
      try {
        // Fetch from seasons_diff
        const { data: seasonData, error: seasonError } = await supabase
          .from("seasons_diff")
          .select("user_id, mxs_rank, mxs")
          .eq("user_id", user.user_id)
          .single();
        if (!seasonData || seasonError) {
          setMxsUserRow(null);
          return;
        }
        // Fetch photo_url from users table
        const { data: usersData, error: userError } = await supabase
          .from("users_duplicate")
          .select("uid, photo_url")
          .eq("uid", user.user_id);
        let photo_url = undefined;
        if (!userError && usersData && usersData.length > 0) {
          photo_url = usersData[0].photo_url;
        }
        setMxsUserRow({
          user_id: seasonData.user_id,
          rank: seasonData.mxs_rank,
          mxs: seasonData.mxs,
          photo_url,
        });
      } catch (error) {
        setMxsUserRow(null);
      }
    };
    fetchUserMxsRow();
  }, [user]);

  const handleMxsLeaderboardPrev = () => {
    if (mxsLeaderboard.hasPrev) {
      fetchMxsLeaderboard(mxsLeaderboard.page - 1);
    }
  };
  const handleMxsLeaderboardNext = () => {
    if (mxsLeaderboard.hasNext) {
      fetchMxsLeaderboard(mxsLeaderboard.page + 1);
    }
  };

  const handleCopyToClipboard = (text) => {
    clipboardCopy(text);
    toast.success("Copied to clipboard!");
  };

  const triggerhandleConnectDiscord = async () => {
    setIsLoadingModalOpen(true);

    // try {
    //   const verifyURL = await handleConnectDiscord();
    //   window.open(verifyURL, "_self");
    // } catch (error) {
    //   console.error("An error occurred during Discord user addition:", error.message);
    // }

    // setIsLoadingModalOpen(false);
  };

  const handleVerifyEmail = async () => {
    setIsEmailModalOpen(true);
  };

  const handleConnectProfilePicture = async () => {
    // We should redirect the user to the profile picture upload page

    router.push("/profile");
  };

  const handleConnectWallet = async () => {
    // Connect Wallet
  };

  const handleConnectTelegram = async () => {
    // connect your telegram
  };

  const handleConnectGoogle = async () => {
    if (user) {
      router.push(`/api/verify/google/start?user_id=${user?.uid}`);
    }
  };

  const triggerHandleConnectX = async () => {
    // connect your twitter
    if (user) {
      router.push(`/api/verify/twitter/start?user_id=${user?.uid}`);
    }
  };

  const handleConnectFacebook = async () => {
    // connect your facebook
  };

  const [onboardingTasks, setOnboardingTasks] = React.useState([
    {
      id: "wallet",
      title: "Connect Wallet",
      points: 10,
      active: true,
      completed: true,
      icon: "ic:baseline-wallet",
      onClick: handleConnectWallet,
      hidden: false,
      claimed: false,
    },
    {
      id: "email",
      title: "Connect Email",
      points: 10,
      active: true,
      completed: false,
      icon: "mdi:email-outline",
      onClick: handleVerifyEmail,
      hidden: false,
      claimed: false,
    },
    {
      id: "twitter",
      title: "Connect Twitter",
      points: 10,
      active: true,
      completed: false,
      icon: "fa6-brands:square-x-twitter",
      onClick: triggerHandleConnectX,
      hidden: false,
      claimed: false,
    },
    {
      id: "profile-picture",
      title: "Upload Profile Picture",
      points: 5,
      active: true,
      completed: false,
      icon: "ic:outline-account-circle",
      onClick: handleConnectProfilePicture,
      hidden: false,
      claimed: false,
    },
    {
      id: "discord",
      title: "Connect Discord",
      points: 10,
      active: false,
      completed: false,
      icon: "ic:baseline-discord",
      onClick: triggerhandleConnectDiscord,
      hidden: false,
      claimed: false,
    },
    {
      id: "telegram",
      title: "Connect Telegram",
      points: 10,
      active: false,
      completed: false,
      icon: "ic:baseline-telegram",
      onClick: handleConnectTelegram,
      hidden: false,
      claimed: false,
    },
    {
      id: "google",
      title: "Connect Google",
      points: 10,
      active: true,
      completed: false,
      icon: "bi:google",
      onClick: handleConnectGoogle,
      hidden: false,
      claimed: false,
    },
    {
      id: "facebook",
      title: "Connect Facebook",
      points: 10,
      active: false,
      completed: false,
      icon: "ic:baseline-facebook",
      onClick: handleConnectFacebook,
      hidden: false,
      claimed: false,
    },
  ]);

  return (
    <Fragment>
      <div className="flex flex-col mt-8">
        {/* MXS Card */}
        <div className="not-logged-in px-4 py-2 font-bold text-md rounded-xl flex justify-between items-center min-h-[72px] mb-4">
          <Fragment>
            {user ? (
              <Fragment>
                <div className="flex-1 gothamMedium flex flex-row items-center bg-metaxseed-content-gray rounded-xl pl-2 pr-8 py-2">
                  <Image
                    src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                    className="w-8 h-8 mr-2"
                    alt="MXS"
                    width={200}
                    height={200}
                  />
                  <div className="flex flex-1 flex-row items-end">
                    <span className="text-2xl font-bold text-white mr-2">
                      {mxsLoading ? "..." : mxs}
                    </span>
                    <span className="text-md font-light text-white">MXS</span>
                  </div>
                </div>

                <div className="flex-1 flex justify-end">
                  <Button
                    text="Details"
                    className="bg-metaxseed-yellow text-metaxseed-dark-blue text-sm font-semibold rounded-full px-4 py-2 hover:jello-horizontal"
                    icon="ph:arrow-right-bold"
                    iconPosition="right"
                    iconClass="text-metaxseed-dark-blue text-sm"
                    onClick={() => {
                      window.location.href = "/points-details";
                    }}
                  />
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <div className="flex-1 flex flex-col">
                  <span>Connect your wallet</span>
                  <span>to view your MXS</span>
                </div>

                <div className="flex-1 flex justify-end">
                  <w3m-connect-button />
                </div>
              </Fragment>
            )}
          </Fragment>
        </div>
        {/* Gold Card (restored) */}
        <div className="not-logged-in px-4 py-2 font-bold text-md rounded-xl flex justify-between items-center min-h-[72px]">
          <Fragment>
            {user ? (
              <Fragment>
                <div className="flex-1 gothamMedium flex flex-row items-center bg-metaxseed-content-gray rounded-xl pl-2 pr-8 py-2">
                  <Image
                    src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729068489/gold_lr_h4yg2m.png"
                    className="w-8 h-8 mr-2"
                    alt="MXS GOLD"
                    width={200}
                    height={200}
                  />
                  <div className="flex flex-1 flex-row items-end">
                    <span className="text-2xl font-bold text-white mr-2">
                      {userPoints?.all_time_mxs_gold_with_bonuses}
                    </span>
                    <span className="text-md font-light text-white">GOLD</span>
                  </div>
                </div>

                <div className="flex-1 flex justify-end">
                  <Button
                    text="Details"
                    className="bg-metaxseed-yellow text-metaxseed-dark-blue text-sm font-semibold rounded-full px-4 py-2 hover:jello-horizontal"
                    icon="ph:arrow-right-bold"
                    iconPosition="right"
                    iconClass="text-metaxseed-dark-blue text-sm"
                    onClick={() => {
                      setTabIndex(1);
                    }}
                  />
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <div className="flex-1 flex flex-col">
                  <span>Connect your wallet</span>
                  <span>to start earning rewards</span>
                </div>

                <div className="flex-1 flex justify-end">
                  <w3m-connect-button />
                </div>
              </Fragment>
            )}
          </Fragment>
        </div>

        <div className="flex flex-col mt-8 bg-metaxseed-content-gray rounded-xl missions-collapsible-wrapper">
          <div className="flex flex-col px-4 mb-4 py-4 leading-none items-start">
            <div className="flex items-center leading-none mb-2 px-4">
              <Icon
                icon="heroicons-outline:calendar"
                className="text-metaxseed-light-gray text-md mr-2 leading-none"
              />
              <span className="text-md font-bold text-white leading-none mt-1">
                {new Date().toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </span>
            </div>

            <span className="text-xs font-light text-metaxseed-light-gray leading-none mb-4 px-4">
              New claim once countdown expires
            </span>

            {user ? (
              <div className="text-white text-xs flex items-center flex-grow px-4 py-2">
                {user.user_id || user.uid}{" "}
                <button
                  onClick={() => handleCopyToClipboard(user?.user_id)}
                  className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400 ml-2"
                >
                  <Icon
                    icon="solar:copy-linear"
                    className="text-metaxseed-gray"
                  />
                </button>
              </div>
            ) : null}

            <div className="text-sm gothamBook rounded-xl p-4 bg-metaxseed-dark-gray text-metaxseed-light-gray leading-none mt-4 w-full">
              Missions Reset Countdown:{" "}
              <span className="gothamMedium">
                {state.hours.toString().length === 1
                  ? `0${state.hours}`
                  : state.hours}
                :
                {state.minutes.toString().length === 1
                  ? `0${state.minutes}`
                  : state.minutes}
                :
                {state.seconds.toString().length === 1
                  ? `0${state.seconds}`
                  : state.seconds}
              </span>
            </div>
          </div>

          <Collapsible trigger="Onboarding" transitionTime={150} open={true}>
            {!loading && !innerLoading ? (
              <Fragment>
                <div
                  className={
                    !loading && !innerLoading && userHandles?.length > 0
                      ? ""
                      : "onboardingMissionsWrapper"
                  }
                >
                  {!loading &&
                  !innerLoading &&
                  userHandles?.length > 0 ? null : (
                    <div className="z-[1] absolute flex justify-center items-center text-center w-auto h-auto top-[50%] left-[50%] transform translate-x-[-50%] translate-y-[-50%] bg-metaxseed-dark-gray rounded-xl p-4">
                      <span className="gothamBook text-metaxseed-light-gray leading-relaxed font-semibold">
                        Login to start onboarding
                      </span>
                    </div>
                  )}
                  <div
                    className={
                      userHandles?.length > 0 ? "" : "onboardingMissions"
                    }
                  >
                    {onboardingTasks.map((task, i) => (
                      <Fragment key={i}>
                        {task.hidden ? null : (
                          <div
                            key={task.id}
                            className="flex flex-row items-center py-2 onboardingMission"
                            data-testid="onboardingMission"
                          >
                            <div className="flex flex-row items-center">
                              <Icon
                                icon={task.icon}
                                className="text-metaxseed-light-gray text-md mr-4 leading-none w-6 h-6 flex items-center justify-center text-center"
                              />
                            </div>

                            <div className="flex-1 flex flex-row items-center">
                              <span
                                className="gothamBook text-sm text-metaxseed-light-gray leading-none"
                                data-testid="onboardingMissionTitle"
                              >
                                {task.title}
                              </span>
                            </div>

                            <div className="flex justify-end items-center">
                              <Button
                                text={
                                  checkFailedBindsForDisabling(task) === false
                                    ? "Timeout"
                                    : task.completed
                                    ? ""
                                    : task.active
                                    ? task.completed && !task.claimed
                                      ? "Claim " + task.points + " Gold"
                                      : task.claimed
                                      ? "Connect"
                                      : "Connect"
                                    : "Soon"
                                }
                                disabled={
                                  checkFailedBindsForDisabling(task) === false
                                    ? true
                                    : task.completed
                                    ? true
                                    : task.active
                                    ? false
                                    : true
                                }
                                className={
                                  (checkFailedBindsForDisabling(task) === false
                                    ? "bg-metaxseed-yellow text-metaxseed-dark-blue min-w-32"
                                    : task.completed
                                    ? "bg-metaxseed-orange !opacity-100"
                                    : task.active
                                    ? "bg-metaxseed-yellow text-metaxseed-dark-blue hover:jello-horizontal min-w-32"
                                    : "bg-metaxseed-gray min-w-32") +
                                  " gothamMedium font-normal text-white text-sm rounded-full px-4 py-2 w-full"
                                }
                                icon={
                                  checkFailedBindsForDisabling(task) === false
                                    ? "ph:clock"
                                    : task.completed
                                    ? "ph:check-bold"
                                    : task.active
                                    ? ""
                                    : "ph:clock"
                                }
                                iconPosition="right"
                                onClick={
                                  checkFailedBindsForDisabling(task) === false
                                    ? null
                                    : task.completed
                                    ? null
                                    : task.active
                                    ? task.onClick
                                    : null
                                }
                                iconClass={
                                  (!task.completed && task.active
                                    ? "text-metaxseed-dark-blue"
                                    : "text-white") + " text-base"
                                }
                                dataTooltipId={
                                  checkFailedBindsForDisabling(task) === false
                                    ? "timeout-tooltip"
                                    : task.completed
                                    ? "claimed-tooltip"
                                    : ""
                                }
                                dataTestId={"onboardingMissionButton"}
                              />

                              <Tooltip
                                id="claimed-tooltip"
                                content={`Go to Profile to update.`}
                                place={"left"}
                                className="!rounded-full px-4 py-2 gothamBook font-normal !bg-metaxseed-dark-gray text-white"
                              />

                              <Tooltip
                                id="timeout-tooltip"
                                content={`Please wait for a while before trying again.`}
                                place={"left"}
                                className="!rounded-full px-4 py-2 gothamBook font-normal !bg-metaxseed-dark-gray text-white"
                              />
                            </div>
                          </div>
                        )}
                      </Fragment>
                    ))}
                  </div>
                </div>
              </Fragment>
            ) : null}

            {innerLoading ||
              (loading && (
                <div className="flex items-center justify-center py-16">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400"></div>
                </div>
              ))}
          </Collapsible>

          {/* MXS Leaderboard Dropdown */}
          <Collapsible
            trigger="MXS Leaderboard"
            transitionTime={150}
            open={true}
          >
            <div className="bg-metaxseed-content-gray rounded-xl py-4 mt-4">
              {/* Table Header */}
              <div className="flex flex-row items-stretch justify-start w-full mb-2 pl-2 pr-1">
                <div className="text-white text-sm gothamMedium w-16 flex items-center">
                  Rank
                </div>
                <div className="text-white text-sm gothamMedium flex items-center flex-grow">
                  UID
                </div>
                <div className="text-white text-sm gothamMedium w-24 flex items-center">
                  Points
                </div>
              </div>
              {mxsLeaderboardLoading ? (
                <div className="flex items-center justify-center min-h-[337px]">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400"></div>
                </div>
              ) : (
                <>
                  {Array.isArray(mxsLeaderboard.leaderboard) &&
                  mxsLeaderboard.leaderboard.length > 0 ? (
                    <div className="flex flex-col items-stretch justify-start w-full">
                      {/* Current User Row (highlighted) */}
                      {user && (
                        <div className="flex flex-col items-stretch justify-start w-full mb-4">
                          <div className="flex flex-row items-stretch justify-start w-full bg-metaxseed-orange rounded-lg py-1 pl-2 pr-1">
                            <div className="py-1 text-white text-sm gothamMedium w-16 flex items-center">
                              #{mxsUserRow?.rank || "#"}
                            </div>
                            <div className="py-1 text-white text-sm gothamBook flex items-center flex-grow">
                              <Image
                                src={
                                  mxsUserRow?.photo_url ||
                                  "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                                }
                                className="w-6 h-6 mr-2 rounded-full bg-black-500"
                                alt="User Pfp"
                                width={200}
                                height={200}
                              />
                              <span>
                                {mxsUserRow?.user_id?.substring(0, 4) || "..."}
                                ...
                                {mxsUserRow?.user_id?.substring(
                                  mxsUserRow?.user_id?.length - 3
                                ) || ""}
                              </span>
                              <button
                                onClick={() => {
                                  clipboardCopy(mxsUserRow?.user_id || "");
                                  toast.success("Copied to clipboard!");
                                }}
                                className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400 ml-2"
                              >
                                <Icon
                                  icon="solar:copy-linear"
                                  className="text-metaxseed-gray"
                                />
                              </button>
                            </div>
                            <div className="py-1 px-2 text-white text-sm gothamMedium rounded-lg w-24 flex items-center bg-metaxseed-content-gray">
                              <Image
                                src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                                className="w-6 h-6 mr-2"
                                alt="MXS"
                                width={200}
                                height={200}
                              />
                              <span className="text-sm font-semibold text-zinc-100">
                                {mxsUserRow?.mxs?.toLocaleString() || "0"}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                      {mxsLeaderboard.leaderboard.map((entry, index) => (
                        <div
                          key={entry.user_id || index}
                          className="flex flex-row items-stretch justify-start w-full mb-1 bg-metaxseed-dark-gray rounded-lg py-1 pl-2 pr-1"
                        >
                          <div className="py-1 text-white text-sm gothamMedium w-16 flex items-center">
                            #{(mxsLeaderboard.page - 1) * 5 + index + 1}
                          </div>
                          <div className="py-1 text-white text-sm gothamBook flex items-center flex-grow">
                            <Image
                              src={
                                entry.photo_url ||
                                "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                              }
                              className="w-6 h-6 mr-2 rounded-full bg-black-500"
                              alt="User Pfp"
                              width={200}
                              height={200}
                            />
                            <span>
                              {entry.user_id?.substring(0, 4)}...
                              {entry.user_id?.substring(
                                entry.user_id.length - 3
                              )}
                            </span>
                            <button
                              onClick={() => {
                                clipboardCopy(entry.user_id);
                                toast.success("Copied to clipboard!");
                              }}
                              className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400 ml-2"
                            >
                              <Icon
                                icon="solar:copy-linear"
                                className="text-metaxseed-gray"
                              />
                            </button>
                          </div>
                          <div className="py-1 px-2 text-white text-sm gothamMedium rounded-lg w-24 flex items-center bg-metaxseed-content-gray">
                            <Image
                              src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                              className="w-6 h-6 mr-2"
                              alt="MXS"
                              width={200}
                              height={200}
                            />
                            <span className="text-sm font-semibold text-zinc-100">
                              {entry.mxs?.toLocaleString() || "0"}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center text-zinc-400 py-4">
                      No leaderboard data available.
                    </div>
                  )}
                  {/* Pagination Controls */}
                  <div className="flex flex-row items-center justify-between mt-4 pt-4 border-t border-zinc-700 gap-2">
                    <Button
                      className={
                        "text-white border-zinc-600 flex items-center justify-center w-1/2 px-0 py-1 rounded-lg text-lg " +
                        (mxsLeaderboard.hasPrev
                          ? "bg-metaxseed-blue "
                          : "bg-metaxseed-gray")
                      }
                      onClick={handleMxsLeaderboardPrev}
                      disabled={!mxsLeaderboard.hasPrev}
                    >
                      <Icon icon="ph:caret-left-bold" className="text-xl" />
                    </Button>
                    <Button
                      className={
                        "text-white flex items-center justify-center w-1/2 px-0 py-1 rounded-lg text-lg " +
                        (mxsLeaderboard.hasNext
                          ? "bg-metaxseed-blue "
                          : "bg-metaxseed-gray")
                      }
                      onClick={handleMxsLeaderboardNext}
                      disabled={!mxsLeaderboard.hasNext}
                    >
                      <Icon icon="ph:caret-right-bold" className="text-xl" />
                    </Button>
                  </div>
                </>
              )}
            </div>
          </Collapsible>

          <Collapsible
            trigger="Gold Leaderboard"
            transitionTime={150}
            open={true}
          >
            <LeaderBoard
              user={user}
              leaderboard={leaderboard}
              leaderboardLoading={leaderboardLoading}
              leaderboardTabChange={leaderboardTabChange}
              leaderboardHandleNext={leaderboardHandleNext}
              leaderboardHandlePrev={leaderboardHandlePrev}
              userPoints={userPoints}
            />
          </Collapsible>
        </div>
      </div>

      {isEmailModalOpen && (
        <EmailModal
          user={user}
          isOpen={isEmailModalOpen}
          onClose={(event) => {
            if (event) {
              setIsEmailModalOpen(false);
              window.location = window.location.href.split("?")[0];
            }
          }}
          uid={user?.user_id}
        />
      )}

      {isLoadingModalOpen && (
        <LoadingModal
          isOpen={isLoadingModalOpen}
          onClose={(event) => {
            if (event) {
              setIsLoadingModalOpen(false);
            }
          }}
        />
      )}

      {showSuccessModal && (
        <MessageModal
          title={`Success!`}
          fireworks={true}
          status={true}
          centered
          activeModal={showSuccessModal}
          className="max-w-xl successModalShadow"
          onClose={() => {
            setShowSuccessModal(false);
            setClaimedRewardAmount(0);
            window.location = window.location.href.split("?")[0];
          }}
        >
          <div className="flex items-center">
            <Image
              src={
                "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_nodes%2Fnode_chest.png?alt=media&token=f064df08-466f-438a-b1df-e0ffdf519a30&w=384&q=75"
              }
              width={285}
              height={285}
              alt="Claimed Reward"
              className="mb-4 max-h-[100px] xl:max-h-[200px] !max-w-fit mx-auto"
            />
          </div>
          <div className="font-medium py-4 text-center">
            {claimedRewardAmount !== 0 ? (
              <span className="font-bold">{claimedRewardAmount} MXS GOLD</span>
            ) : (
              "Reward"
            )}{" "}
            claimed successfully!
          </div>
        </MessageModal>
      )}

      {showErrorModal && (
        <MessageModal
          title={activeErrorTitle || "Error"}
          status={false}
          centered
          activeModal={showErrorModal}
          className="max-w-xl errorModalShadow"
          onClose={(event) => {
            if (event) {
              setShowErrorModal(false);
              setTimeout(() => {
                setActiveError(null);
              }, 300);
            }
          }}
        >
          <div className="font-medium py-2">
            {activeError || "An error occurred. Please try again later."}
          </div>
        </MessageModal>
      )}
    </Fragment>
  );
}
